/**
 * @generated SignedSource<<e01e471118cb253094890c123b35dacb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type actionWidgetContent$data = {
  readonly __typename: string;
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleCommentsTriggerArticle" | "articlePrintArticle" | "entityLink">;
  readonly " $fragmentType": "actionWidgetContent";
};
export type actionWidgetContent$key = {
  readonly " $data"?: actionWidgetContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"actionWidgetContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "actionWidgetContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "articleCommentsTriggerArticle"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "articlePrintArticle"
        }
      ],
      "type": "Article",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "86007bf5e345f4e531ed9fdfa27c7819";

export default node;
